import { Button, message, Modal, Select, Space, Spin, Table, TableColumnsType, TableProps, Typography } from "antd";
import { useEffect, useState } from "react";
import { BsTable } from "react-icons/bs";
import { HiOutlineClipboardDocumentCheck } from "react-icons/hi2";
import { PiChartBarFill } from "react-icons/pi";
import { useSearchParams } from "react-router-dom";
import {
  MonthVocEmiss,
  ReportVocEmission,
  Option,
  OptionFilter,
  Filter,
  SummaryVocEmission,
  UnitTerminalVoc,
  WidthCol,
} from "src/entity/terminal-marketing/terminal-marketing.entity";
import { roleCompanyAdmin } from "src/pages/VocsInventory/Combustion/PermissionCheck/PermissionCheck";
import {
  getInfoStepApprove,
  getOptionMonthSubmit,
  getOptions,
  getOptionVocApprove,
  getReportVocEmission,
  getYear,
  submitReportVoc,
  updateApproveStep,
} from "src/services/terminal-marketing.service";
import { profileStore } from "src/stores/profile-store";
import { componentPalette } from "src/theme/component-palette";
import { parseAndFormatScientificNumber } from "src/utils/process-number";
import { useShallow } from "zustand/react/shallow";
import { CommonError, CommonSuccess } from "src/entity/common/menus-enum.enum";
import ModalApproveMonth from "src/components/ModalApproveMonth/ModalApproveMonth";
import { settingStore } from "src/stores/setting-store";
import ModalApproveStep from "src/components/ModalApproveStep/ModalApproveStep";
import { ApproveBody, DataApprove, OptionApproval, ResponseAPI } from "src/entity/voc-approve/voc-approve.entity";
import { excelStore } from "src/stores/excel-store.interface";
import { TbRefresh } from "react-icons/tb";
import { UnitAllEnum } from "src/entity/common/unit.constant";
import { canApproveAndViewTable } from "../../PermissionCheck/PermissionCheck";
import useNavigationMenu from "src/hook/useNavigationMenu";
import { terminalStore } from "src/stores/terminal-store";
import axios from "axios";
import { CloseOutlined, InfoCircleOutlined } from "@ant-design/icons";
import { companyStore } from "src/stores/company-store";
import { generateYearArray } from "src/utils/array";
import { getInfoStepApproval, getOptionVocApproval } from "src/services/voc-approval";
import { convertEmissionWord } from "src/entity/common/global.entity";
import { utilsStore } from "src/stores/utils-store";
import { addCenterAlign } from "src/components/AntdCustomPart/TableTitle.tsx/TableTitle";

const { Text } = Typography;
type OnChange = NonNullable<TableProps<any>["onChange"]>;
type Filters = Parameters<OnChange>[1];

const ReportVocEmissionTable = () => {
  const menu = "transportation";

  const profile = profileStore(useShallow((state) => state.profile));
  const loadingProfile = profileStore(useShallow((state) => state.loading));
  const [companyId, setCompanyId] = useState<string>("");
  const userId = profile?.userId;
  const email = profile?.email;
  const name = profile?.name;

  const [searchParams] = useSearchParams();
  const yearParam = searchParams.get("year");
  const monthParam = searchParams.get("month");
  const approveNoParam = searchParams.get("approveNo");
  const companyParam = searchParams.get("companyId");

  const [messageApi, contextHolder] = message.useMessage();
  const [data, setData] = useState<ReportVocEmission[]>();
  const [filter, setFilter] = useState<Filters>({});
  const [optionYears, setOptionYears] = useState<number[]>([]);
  const [loading, setLoading] = useState(false);
  const [filterLoading, setLoadingFilter] = useState(false);
  const { permissions } = useNavigationMenu();
  const [selectedButton, setSelectedButton] = useState<string>("table");
  const [selectedYear, setSelectedYear] = useState<number | null>(null);
  const [selectedApprove, setSelectedApprove] = useState<string>();
  const [optionApprove, setOptionApprove] = useState<Option[]>([]);
  const [selectedEmission, setSelectedEmission] = useState<string>("tvoc");
  const [optionEmissions, setOptionEmissions] = useState<Option[]>([]);
  const [openModalApproveStep, setOpenModalApproveStep] = useState<boolean>(false);
  const [openModalApproveMonth, setOpenModalApproveMonth] = useState<boolean>(false);
  const [optionsFilter, setOptionFilter] = useState<OptionFilter[]>([]);
  const [optionMonth, setOptionMonth] = useState<Option[]>([]);
  const currentYear = new Date().getFullYear();
  const [summary, setSummary] = useState<SummaryVocEmission[]>();
  const [approveData, setApproveData] = useState<DataApprove | null>(null);

  // For new ui approval page
  const [optionApproval, setOptionApproval] = useState<OptionApproval | null>();
  const [selectedYearApprove, setSelectedYearApprove] = useState<number | null>();
  const [selectedMonthApprove, setSelectedMonthApprove] = useState<string | null>();
  const [selectedNoApprove, setSelectedNoApprove] = useState<number | null>();

  const [selectedUnit, setSelectedUnit] = useState<string>(UnitAllEnum.KG);
  const [dataAllUnit, setDataAllUnit] = useState<UnitTerminalVoc>();
  const [widthMainColumns, setWidthMainColumnsl] = useState<{ [key: string]: string }>({});

  const [widthTotal, setWidthTotal] = useState<string>("");
  const [widthCol, setWidthCol] = useState<WidthCol>({
    jan: "",
    feb: "",
    mar: "",
    apr: "",
    may: "",
    jun: "",
    jul: "",
    aug: "",
    sep: "",
    oct: "",
    nov: "",
    dec: "",
  });

  const getTextWidth = utilsStore(useShallow((state) => state.getTextWidth));

  const getAreaByCompanyId = companyStore(useShallow((state) => state.getAreaByCompanyId));
  const areaMaster = companyStore(useShallow((state) => state.dataArea));

  const emissionMaster = settingStore(useShallow((state) => state.emission));
  const getEmission = settingStore(useShallow((state) => state.getEmission));

  const excelSetSelectedYear = excelStore(useShallow((state) => state.setSelectedYear));
  const excelSetQueryStr = excelStore(useShallow((state) => state.setQueryStr));

  const getChemicalProperty = terminalStore(useShallow((state) => state.getChemicalProperty));
  const chemicalPropertyMaster = terminalStore(useShallow((state) => state.chemicalProperty));

  const getLoadingMethod = terminalStore(useShallow((state) => state.getLoadingMethod));
  const loadingMethodMaster = terminalStore(useShallow((state) => state.loadingMethod));

  const getEmissionControl = terminalStore(useShallow((state) => state.getEmissionControl));
  const emissionControlMaster = terminalStore(useShallow((state) => state.emissionControl));

  const fetchYear = () => {
    const years = generateYearArray();
    setOptionYears(years as number[]);
    setSelectedYear(years[0] as number);
  };

  const warningAlert = (message: string | string[], action: string) => {
    const warnModal = Modal.confirm({
      title: (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span>Can not {action}</span>
          <CloseOutlined onClick={() => warnModal.destroy()} style={{ cursor: "pointer" }} />
        </div>
      ),
      content: message,
      okText: "OK",
      icon: <InfoCircleOutlined style={{ color: componentPalette.redThird }} />,
      okButtonProps: { style: { textAlign: "center", backgroundColor: componentPalette.primary } },
      cancelButtonProps: { style: { display: "none" } },
      onOk: () => {},
      className: "custom-tmp-modal-warning",
    });
  };

  const handleChangeUnit = () => {
    if (selectedUnit === UnitAllEnum.KG) {
      setSelectedUnit(UnitAllEnum.TON);
    } else if (selectedUnit === UnitAllEnum.TON) {
      setSelectedUnit(UnitAllEnum.KG);
    }
  };

  const fetchReportVocEmission = async () => {
    try {
      if (companyId && selectedYear && selectedEmission) {
        setLoading(true);
        const query = createParamFilter();
        const response = await getReportVocEmission(companyId, query);
        if (response.data.code === 200) {
          setDataAllUnit(response.data.data);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const fetchOption = async () => {
    try {
      if (companyId && selectedYear) {
        const response = await getOptions(companyId, selectedYear);
        if (response.data.code === 200) {
          const data = response.data.data.filter;
          setOptionFilter(data);
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const resetApprovalState = () => {
    setApproveData(null);
    setSelectedApprove("");
  };

  const fetchInfoStepApprove = async () => {
    try {
      if (companyId && selectedYearApprove && selectedMonthApprove && selectedNoApprove) {
        setLoading(true);
        if (selectedYearApprove && selectedMonthApprove && selectedNoApprove) {
          const query = new URLSearchParams({
            menu,
            year: selectedYearApprove.toString(),
            month: selectedMonthApprove,
            approveNo: selectedNoApprove.toString(),
          }).toString();
          const response = await getInfoStepApproval(query);
          if (response.data.code === 200) {
            const approveInfo = response.data.data;
            setApproveData(approveInfo);
            setSelectedApprove(approveInfo._id || "");
          }
        } else {
          setApproveData(null);
          resetApprovalState();
        }
      } else {
        resetApprovalState();
      }
    } catch (error) {
      console.error("Error fetching approval data:", error);
      resetApprovalState();
    } finally {
      setLoading(false);
    }
  };

  const fetchMonthOfSubmit = async () => {
    try {
      if (selectedYear && companyId) {
        setLoadingFilter(true);
        const response = await getOptionMonthSubmit(companyId, selectedYear);
        if (response.data.code === 200) {
          const month = response.data.data;
          setOptionMonth(month);
        } else {
          setOptionMonth([]);
        }
      }
    } catch (error) {
      console.error(error);
      setOptionMonth([]);
    } finally {
      setLoadingFilter(false);
    }
  };

  const resetSelections = () => {
    setOptionApproval(null);
    setSelectedYearApprove(null);
    setSelectedMonthApprove(null);
    setSelectedNoApprove(null);
  };

  const fetchOptionVocApprove = async () => {
    try {
      if (companyId) {
        if (yearParam && !selectedYearApprove && !selectedMonthApprove) return;

        const queryParams = new URLSearchParams({ menu });
        if (selectedYearApprove) {
          queryParams.append("year", selectedYearApprove.toString());
        }
        if (selectedMonthApprove) {
          queryParams.append("month", selectedMonthApprove);
        }

        const queryString = queryParams.toString();
        // Fetch data
        const response = await getOptionVocApproval(queryString);

        // const response = await getOptionVocApprove(companyId);
        if (response.data.code === 200) {
          const { approveNo } = response.data.data || {};
          setOptionApproval({ ...response.data.data });

          if (approveNo) {
            if (!selectedNoApprove && selectedYearApprove && selectedMonthApprove && approveNo?.length === 1) {
              setSelectedNoApprove(approveNo[0]);
            }
          } else {
            resetSelections();
          }
        } else {
          resetSelections();
        }
      }
    } catch (error) {
      console.error(error);
    }
  };

  const handleSubmitReport = async (checkMonths: any) => {
    try {
      if (companyId && userId) {
        const payload = {
          userId: userId,
          months: checkMonths,
          year: selectedYear,
        };
        setLoading(true);
        const response = await submitReportVoc(companyId, payload);
        if (response.data.code === 200) {
          setOpenModalApproveMonth(false);
          setLoading(false);
          messageApi.open({
            type: "success",
            content: CommonSuccess.SUBMIT_SUCCESSFULL,
          });
          fetchMonthOfSubmit();
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SUBMIT_FAIL,
          });
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const responseData = error?.response?.data as ResponseAPI;
        if (error?.response?.status === 400) {
          warningAlert(String(responseData.message), "submit");
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.SUBMIT_FAIL,
          });
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createParamFilter = () => {
    let queryParam = "";

    if (selectedYear) {
      queryParam += `year=${selectedYear}`;
    }

    queryParam += `&emission=${selectedEmission}`;
    queryParam += `&unit=${selectedUnit}`;

    if (filter) {
      const str = Object.entries(filter)
        .filter(([, value]) => value)
        .map(([key, value]) => `&${key}=[${value?.join(",")}]`)
        .join("");
      queryParam += str;
    }
    // console.log("");
    return queryParam;
  };

  const handleOpenModalApproveMonth = () => {
    setOpenModalApproveMonth(true);
  };

  const handleChangeEmission = (value: string) => {
    setSelectedEmission(value);
  };

  const handleButtonMenuClick = (buttonName: string) => {
    setSelectedButton(buttonName);
    if (buttonName === "table") {
      setOpenModalApproveStep(false);
      if (yearParam && monthParam && approveNoParam) {
        searchParams.delete("yearParam");
        searchParams.delete("monthParam");
        searchParams.delete("approveNoParam");
        searchParams.delete("companyId");
      }
    } else if (buttonName === "approve") {
      fetchOptionVocApprove();
      setOpenModalApproveStep(true);
      if (yearParam) setSelectedYearApprove(Number(yearParam));
    }
  };

  const handleYearChange = (value: number) => {
    setSelectedYear(value);
  };

  const handleApproveReport = async (approveBody: ApproveBody, action: string) => {
    try {
      if (companyId) {
        setLoading(true);
        const response = await updateApproveStep(companyId, approveBody);
        if (response.data.code == 200) {
          if (action === "approved") {
            messageApi.open({
              type: "success",
              content: CommonSuccess.APPROVED_SUCCESSFULL,
            });
          } else if (action === "reject") {
            messageApi.open({
              type: "success",
              content: CommonSuccess.REJECT_SUCCESSFULL,
            });
          }
          await fetchInfoStepApprove();
          await fetchMonthOfSubmit();
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.APPROVED_FAIL,
          });
        }
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        const responseData = error?.response?.data as ResponseAPI;
        const actionStr = action === "approved" ? "approve" : "reject";
        if (error?.response?.status === 400) {
          warningAlert(String(responseData.message), actionStr);
        } else {
          messageApi.open({
            type: "error",
            content: CommonError.APPROVED_FAIL,
          });
        }
      }
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const mapFilter = (key: string): Filter[] | [] => {
    const resultFilter = optionsFilter.find((item) => item.key === key)?.filter;
    if (resultFilter) {
      const filter: Filter[] = resultFilter?.map((value: any) => {
        let text = value;
        if (key === "area") {
          text = getMasterLabel("area", text);
        } else if (key === "chemicalId") {
          text = getMasterLabel("chemicalId", text);
        } else if (key === "loadingById") {
          text = getMasterLabel("loadingById", text);
        } else if (key === "emissionControlId") {
          text = getMasterLabel("emissionControlId", text);
        }
        return {
          text,
          value: value,
        };
      });
      return filter;
    } else {
      return [];
    }
  };

  const onTableChange: TableProps<ReportVocEmission>["onChange"] = (_, filters: any) => {
    setFilter(filters);
  };

  const fetchMaster = async () => {
    await getEmission({ type: "global", label: "Emission" });
    if (emissionMaster[0] && emissionMaster[0].options) {
      setOptionEmissions(emissionMaster[0].options);
      setSelectedEmission(emissionMaster[0].options[0].value);
    }
  };

  const getMasterLabel = (type: string, text: string) => {
    if (!text || typeof text != "string") return "";
    if (type === "area" && areaMaster) {
      const optValue = areaMaster.find((item) => item._id === text);
      return optValue?.areaName;
    } else if (type === "chemicalId" && chemicalPropertyMaster) {
      const optValue = chemicalPropertyMaster.find((item) => item._id === text);
      return optValue?.chemicalName;
    } else if (type === "loadingById" && loadingMethodMaster) {
      const optValue = loadingMethodMaster.find((item) => item._id === text);
      return optValue?.loadingBy;
    } else if (type === "emissionControlId" && emissionControlMaster) {
      const optValue = emissionControlMaster.find((item) => item._id === text);
      return optValue?.emissionControl;
    } else {
      return text;
    }
  };

  const getWidth = (
    fontSize = "14px",
    fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  ) => {
    const font = `${fontSize} ${fontFamily}`;
    const widthMonth: { [key in keyof SummaryVocEmission]: string } = {} as any;
    months.forEach((month) => {
      const keyMonth = month.dataIndex as keyof SummaryVocEmission;

      const widthAb = summary?.[0]?.[keyMonth] || "";
      const widthIn = summary?.[1]?.[keyMonth] || "";

      const textWidthAb = getTextWidth(String(widthAb), font);
      const textWidthIn = getTextWidth(String(widthIn), font);

      let maxWidth = Math.max(textWidthAb, textWidthIn);

      if (maxWidth < 90) {
        maxWidth = 90;
      }

      widthMonth[keyMonth] = `${maxWidth}px`;
    });
    setWidthCol(widthMonth);
    const widthTotalAb = summary?.[0]?.total || "";
    const widthTotalIn = summary?.[1]?.total || "";
    const textWidthTotalAb = getTextWidth(String(widthTotalAb), font);
    const textWidthTotalIn = getTextWidth(String(widthTotalIn), font);
    let maxWidthTotal = Math.max(textWidthTotalAb, textWidthTotalIn);
    if (maxWidthTotal == 0) {
      maxWidthTotal = 100;
    }
    setWidthTotal(`${maxWidthTotal}px`);
  };

  const getMainColumnsWidth = (
    fontSize = "14px",
    fontFamily = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, 'Noto Sans', sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol', 'Noto Color Emoji'",
  ) => {
    const font = `${fontSize} ${fontFamily}`;
    const widthMainColumnsTmp: { [key in keyof ReportVocEmission]: string } = {} as any;
    const mainColumns = ["chemicalName", "area", "loadingBy", "emission", "unit"];

    if (data && data.length > 0) {
      mainColumns.forEach((column) => {
        let max = 0;

        data.forEach((row) => {
          let value = row[column as keyof ReportVocEmission] ?? "";
          if (["area"].includes(column)) value = getMasterLabel(column, String(value)) ?? "";
          const text = String(value);
          const textWidth = getTextWidth(text, font);
          if (textWidth > max) max = textWidth;
        });

        let labelWidth = 0;
        if (column === "chemicalName") labelWidth = 120;
        if (max < labelWidth) max = labelWidth;

        if (max < 50) max = 100;
        widthMainColumnsTmp[column as keyof typeof widthMainColumnsTmp] = `${max * 1.1}px`;
      });
    }
    setWidthMainColumnsl(widthMainColumnsTmp);
  };

  const handleYearApproveChange = (value: number) => {
    setSelectedYearApprove(value);
    setSelectedMonthApprove(null);
    setSelectedNoApprove(null);
  };

  const handleMonthApprovalChange = (value: string) => {
    setSelectedMonthApprove(value);
    setSelectedNoApprove(null);
  };

  const handleApproveNoChange = (value: number) => {
    setSelectedNoApprove(value);
  };

  const resetFilter = () => {
    setFilter({});
  };

  const initMaster = async () => {
    try {
      const query = "";
      if (profile?.activeCompany._id) {
        setLoading(true);
        await getEmission({ type: "global", label: "Emission" });
        if (emissionMaster[0] && emissionMaster[0].options) {
          setOptionEmissions(emissionMaster[0].options);
          setSelectedEmission(emissionMaster[0].options[0].value);
        }
        await Promise.all([getChemicalProperty(query), getLoadingMethod(query), getEmissionControl(query)]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const removeSarchParam = () => {
    searchParams.delete("year");
    searchParams.delete("month");
    searchParams.delete("approveNo");
    searchParams.delete("companyId");
  };

  useEffect(() => {
    getWidth();
  }, [summary]);

  useEffect(() => {
    getMainColumnsWidth();
  }, [data]);

  useEffect(() => {
    resetFilter();
    if (selectedYear) {
      excelSetSelectedYear(selectedYear);
    }
  }, [selectedYear]);

  useEffect(() => {
    const queryParam = createParamFilter();
    if (queryParam) {
      excelSetQueryStr(queryParam);
    }
  }, [filter, selectedYear, selectedUnit, selectedEmission]);

  useEffect(() => {
    initMaster();
    fetchYear();
  }, []);

  useEffect(() => {
    if (emissionMaster[0] && emissionMaster[0].options) {
      setOptionEmissions(emissionMaster[0].options);
    }
  }, [emissionMaster]);

  useEffect(() => {
    if (profile?.activeCompany?._id) {
      setCompanyId(profile.activeCompany._id);
    }
  }, [profile?.activeCompany]);

  useEffect(() => {
    if (loadingProfile === true) {
      setLoading(true);
    }
  }, [loadingProfile]);

  useEffect(() => {
    const fetchData = async () => {
      if (!companyId) return;

      try {
        setSelectedYear(currentYear);

        if (yearParam && monthParam && approveNoParam) {
          if (companyId === companyParam) {
            handleButtonMenuClick("approve");
            if (yearParam) setSelectedYearApprove(Number(yearParam));
            if (monthParam) setSelectedMonthApprove(monthParam);
            if (approveNoParam) setSelectedNoApprove(Number(approveNoParam));
            removeSarchParam();
          }
        } else if (yearParam) {
          // Case: Redirected from "My Task" to the VOC Emission report with only the year parameter
          if (yearParam) setSelectedYear(Number(yearParam));
          if (Number(yearParam) === Number(selectedYear)) {
            searchParams.delete("year");
          }
        } else {
          setSelectedYearApprove(null);
          setSelectedMonthApprove(null);
          setSelectedNoApprove(null);
        }

        await Promise.all([getAreaByCompanyId(companyId), fetchMaster(), fetchMonthOfSubmit(), fetchOptionVocApprove()]);
      } catch (error) {
        console.error(error);
      }
    };
    fetchData();
  }, [companyId]);

  useEffect(() => {
    setLoading(true);
    fetchOption();
    setLoading(false);
  }, [selectedYear, selectedEmission, companyId]);

  useEffect(() => {
    const fetchData = async () => {
      if (companyId && selectedYear) {
        await Promise.all([fetchReportVocEmission(), fetchMonthOfSubmit()]);
      }
    };
    fetchData();
  }, [filter, selectedEmission, companyId]);

  useEffect(() => {
    if (dataAllUnit && selectedUnit) {
      const dataUnitSelected = dataAllUnit[selectedUnit];
      if (dataUnitSelected) {
        setData(dataUnitSelected.data);
        setSummary(dataUnitSelected.summary);
      }
    }
  }, [dataAllUnit, selectedUnit]);

  useEffect(() => {
    fetchOptionVocApprove();
    fetchInfoStepApprove();
  }, [selectedYearApprove, selectedMonthApprove, selectedNoApprove]);

  const isDisableSubmitButton = () => {
    if (!canApproveAndViewTable(permissions) || data?.length == 0 || optionMonth.length === 0) {
      return true;
    } else {
      return false;
    }
  };

  const buttonStyle = (buttonName: string) => ({
    backgroundColor: selectedButton === buttonName ? componentPalette.primary : "initial",
    color: selectedButton === buttonName ? "white" : "initial",
  });

  const months: MonthVocEmiss[] = [
    { title: "Jan", dataIndex: "jan" },
    { title: "Feb", dataIndex: "feb" },
    { title: "Mar", dataIndex: "mar" },
    { title: "Apr", dataIndex: "apr" },
    { title: "May", dataIndex: "may" },
    { title: "Jun", dataIndex: "jun" },
    { title: "Jul", dataIndex: "jul" },
    { title: "Aug", dataIndex: "aug" },
    { title: "Sep", dataIndex: "sep" },
    { title: "Oct", dataIndex: "oct" },
    { title: "Nov", dataIndex: "nov" },
    { title: "Dec", dataIndex: "dec" },
  ];

  const monthColumns: TableColumnsType<ReportVocEmission> = months.map((month) => ({
    title: month.title,
    width: widthCol[month.dataIndex as keyof WidthCol],
    render: (_, record) => {
      if (record && typeof record === "object") {
        const value = record[month.dataIndex];
        if (typeof value === "number") {
          return value ? <Text>{parseAndFormatScientificNumber(`${value}`, 2)}</Text> : <Text>0</Text>;
        } else {
          return <Text>0</Text>;
        }
      }
    },
  }));

  const staticColumns: TableColumnsType<ReportVocEmission> = [
    {
      title: "No.",
      dataIndex: "no",
      width: 40,
      render: (text: any, record: any, index: number) => {
        return index + 1;
      },
    },
    {
      title: "Chemical Name",
      dataIndex: "chemicalName",
      key: "chemicalId",
      width: widthMainColumns?.chemicalName,
      filters: mapFilter("chemicalId"),
      filteredValue: filter?.chemicalId || null,
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Area",
      dataIndex: "area",
      width: widthMainColumns?.area,
      filters: mapFilter("area"),
      filteredValue: filter?.area || null,
      render: (text) => <Text>{getMasterLabel("area", text)}</Text>,
    },
    {
      title: "Loading By",
      dataIndex: "loadingBy",
      key: "loadingById",
      width: widthMainColumns?.loadingBy,
      filters: mapFilter("loadingById"),
      filteredValue: filter?.loadingById || null,
      render: (text) => <Text>{text}</Text>,
    },
    {
      title: "Emission",
      dataIndex: "emission",
      key: "emission",
      width: widthMainColumns?.emission,
      render: (text) => <Text>{convertEmissionWord(text.toUpperCase())}</Text>,
    },
    {
      title: (
        <>
          <Space>
            Unit
            <Button onClick={handleChangeUnit} type="text" icon={<TbRefresh />} />
          </Space>
        </>
      ),
      dataIndex: "unit",
      width: widthMainColumns?.unit,
      render: (text) => <Text>{text}</Text>,
    },
  ];

  const totalColumns: TableColumnsType<ReportVocEmission> = [
    {
      title: "Total",
      dataIndex: "total",
      width: widthTotal,
      render: (value) => {
        if (typeof value === "number") {
          return value ? <Text>{parseAndFormatScientificNumber(`${value}`, 2)}</Text> : 0;
        } else {
          return 0;
        }
      },
    },
  ];

  const columns: TableColumnsType<ReportVocEmission> = [...staticColumns, ...monthColumns, ...totalColumns];

  return (
    <>
      {contextHolder}

      <div style={{ display: "flex", paddingBottom: "10px", gap: "20px", position: "relative" }}>
        <div>
          <div style={{ display: "flex", gap: "20px" }}>
            {selectedButton === "table" ? (
              <Select
                value={selectedYear}
                style={{ width: 120 }}
                onChange={handleYearChange}
                options={optionYears.map((year) => ({ label: year, value: year }))}
                loading={loading}
                size="middle"
              />
            ) : (
              <div style={{ display: "flex", gap: "10px" }}>
                <Select
                  value={selectedYearApprove}
                  style={{ width: 120 }}
                  onChange={handleYearApproveChange}
                  options={optionApproval?.year?.map((year) => ({ label: year, value: year }))}
                  loading={loading || loadingProfile}
                  size="middle"
                />
                <Select
                  value={selectedMonthApprove}
                  style={{ width: 120 }}
                  onChange={handleMonthApprovalChange}
                  options={optionApproval?.month?.map((month) => ({ label: month.charAt(0).toUpperCase() + month.slice(1), value: month }))}
                  loading={loading || loadingProfile}
                  size="middle"
                />
                <Select
                  value={selectedNoApprove}
                  style={{ width: 120 }}
                  onChange={handleApproveNoChange}
                  options={optionApproval?.approveNo?.map((approveNo) => ({ label: approveNo, value: approveNo }))}
                  loading={loading}
                  size="middle"
                />
              </div>
            )}

            {/* Emission Select */}
            {selectedButton === "table" && (
              <Select
                value={selectedEmission}
                style={{
                  width: 120,
                  visibility: selectedButton === "table" ? "visible" : "hidden",
                }}
                onChange={handleChangeEmission}
                options={optionEmissions}
                loading={loading}
                size="middle"
              />
            )}
          </div>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <Button
            size="middle"
            style={buttonStyle("table")}
            icon={<BsTable style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("table")}
          />
          <Button
            size="middle"
            style={buttonStyle("chart")}
            icon={<PiChartBarFill style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("chart")}
          />
          <Button
            size="middle"
            style={buttonStyle("approve")}
            icon={<HiOutlineClipboardDocumentCheck style={{ fontSize: "18px" }} />}
            onClick={() => handleButtonMenuClick("approve")}
          />
        </div>
      </div>

      {selectedButton === "table" && (
        <Table
          className="w-full"
          style={{ whiteSpace: "nowrap" }}
          dataSource={canApproveAndViewTable(permissions) ? data : []}
          columns={addCenterAlign(columns)}
          onChange={onTableChange}
          rowKey="_id"
          scroll={{ x: "max-content", y: data ? (data?.length === 0 ? undefined : 500) : undefined }}
          loading={loading || loadingProfile || filterLoading}
          pagination={false}
          summary={(pageData) => {
            if (pageData.length > 0) {
              return (
                <Table.Summary fixed="bottom">
                  {summary?.map((row, index) => (
                    <Table.Summary.Row>
                      <Table.Summary.Cell index={index} colSpan={5}>
                        <div style={{ textAlign: "center" }}>
                          <Text>{row.label}</Text>
                        </div>
                      </Table.Summary.Cell>
                      <Table.Summary.Cell index={index} colSpan={1}>
                        <div>
                          <Text>{row.unit}</Text>
                        </div>
                      </Table.Summary.Cell>
                      {months.map((month, idxMonth) => {
                        const keyMonth = month.dataIndex;
                        const total = row[keyMonth as keyof typeof row] as number;
                        return (
                          <>
                            <Table.Summary.Cell index={idxMonth + index} colSpan={1}>
                              <div>
                                <Text>
                                  {total
                                    ? row.key === "intensity"
                                      ? parseAndFormatScientificNumber(`${total}`, 2)
                                      : parseAndFormatScientificNumber(`${total}`, 2)
                                    : 0}
                                </Text>
                                {/* <Text> {total ? formatNumber(total) : 0}</Text> */}
                              </div>
                            </Table.Summary.Cell>
                          </>
                        );
                      })}

                      <Table.Summary.Cell index={19} colSpan={1}>
                        <div>
                          <Text>
                            {row.total
                              ? row.key === "intensity"
                                ? parseAndFormatScientificNumber(`${row.total}`, 2)
                                : parseAndFormatScientificNumber(`${row.total}`, 2)
                              : 0}
                          </Text>
                        </div>
                      </Table.Summary.Cell>
                    </Table.Summary.Row>
                  ))}
                </Table.Summary>
              );
            }
          }}
        />
      )}

      <div style={{ paddingTop: "20px", justifyContent: "flex-end", display: "flex" }}>
        {selectedButton == "table" && profile?.roles.includes(roleCompanyAdmin) && (
          <Button type="primary" style={{}} onClick={handleOpenModalApproveMonth} disabled={isDisableSubmitButton()}>
            Submit
          </Button>
        )}
      </div>

      {openModalApproveMonth && (
        <ModalApproveMonth
          open={openModalApproveMonth}
          intitailMonthly={optionMonth}
          loading={loading || filterLoading}
          onSubmitReport={(checkedMonths) => {
            handleSubmitReport(checkedMonths);
          }}
          onCancelReport={() => {
            setOpenModalApproveMonth(false);
          }}
        />
      )}

      {openModalApproveStep && approveData && userId && selectedApprove && email && name && (
        <>
          {loading || filterLoading ? (
            <Spin style={{ display: "flex", justifyContent: "center", alignItems: "center" }} />
          ) : (
            <ModalApproveStep
              data={approveData}
              userId={userId}
              approveId={selectedApprove}
              email={email}
              name={name}
              onApprove={(approveBody, action) => {
                handleApproveReport(approveBody, action);
              }}
            />
          )}
        </>
      )}
    </>
  );
};

export default ReportVocEmissionTable;
